import { render } from "./Tags.vue?vue&type=template&id=2e2f6c8a"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"

import "./Tags.vue?vue&type=style&index=0&id=2e2f6c8a&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__